export default [
  {
    path: "/master_data/v2",
    redirect: "MasterdataManagementPage2",
    meta: {
      breadcrumb: "Masterdata",
      requireAuthorize: true
    },
    component: {
      render(h) {
        return h("router-view");
      }
    },
    children: [
      {
        path: "",
        name: "MasterdataManagementPage2",
        meta: {
          breadcrumb: "Landing page",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/MasterdataManagementPage.vue")
      },
      {
        path: "translations",
        name: "SandboxAppTranslations",
        meta: {
          breadcrumb: "Translations",
          requireAuthorize: true
        },
        component: () =>
          import(
            /* webpackChunkName: "sandbox" */ "@/components/sandbox/masterdata/Translations.vue"
          )
      },

      {
        path: "mappings",
        name: "SandboxTech3rdpartyMappings",
        meta: {
          breadcrumb: "Mappings",
          requireAuthorize: true
        },
        component: () =>
          import(
            /* webpackChunkName: "sandbox" */ "@/components/sandbox/masterdata/Tech3rdpartyMappings.vue"
          )
      },

      {
        path: "custom_configs",
        name: "SandboxCustomConfigurationsList",
        meta: {
          breadcrumb: "Custom configurations",
          requireAuthorize: true
        },
        component: () =>
          import(
            /* webpackChunkName: "sandbox" */ "@/components/sandbox/masterdata/CustomConfigurationsList.vue"
          )
      },

      {
        path: "products",
        name: "SandboxProductsManagement",
        meta: {
          breadcrumb: "Products",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/ProductsManagement.vue")
      },

      {
        path: "sactions",
        name: "SandboxActions",
        meta: {
          breadcrumb: "Actions",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/ActionsList.vue")
      },

      {
        path: "query_definitions",
        name: "SandboxQueryDefinitions",
        meta: {
          breadcrumb: "Query definitions",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/QueryDefinitions.vue")
      },

      {
        path: "surveys",
        name: "SandboxSurveys",
        meta: {
          breadcrumb: "Surveys",
          requireAuthorize: true
        },
        component: () => import("@/components/sandbox/masterdata/Surveys.vue")
      },

      {
        path: "sanction_reasons",
        name: "SandboxSanctionReasons",
        meta: {
          breadcrumb: "Sanction reasons",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/SanctionReasons.vue")
      },
      {
        path: "sanction_definitions",
        name: "SandboxSanctionDefinitions",
        meta: {
          breadcrumb: "Sanction definitions",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/SanctionDefinitions.vue")
      },

      {
        path: "organisational_funcs",
        name: "SandboxOrganisationalFunctions",
        meta: {
          breadcrumb: "Organisational functions",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/OrganisationalFunctions.vue")
      },
      {
        path: "organisational_titles",
        name: "SandboxOrganisationalTitles",
        meta: {
          breadcrumb: "Organisational titles",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/OrganisationalTitles.vue")
      },

      {
        path: "disciplines",
        name: "SandboxDisciplines",
        meta: {
          breadcrumb: "Disciplines",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/DisciplinesList.vue")
      },
      {
        path: "cancel_reason",
        name: "SandboxCancelReasons",
        meta: {
          breadcrumb: "Cancel reasons",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/CancelReasons.vue")
      },
      {
        path: "reports",
        name: "SandboxReports",
        meta: {
          requireAuthorize: true
        },
        component: () => import("@/components/sandbox/masterdata/Reports.vue")
      },
      {
        path: "sandbox_legalforms",
        name: "SandboxLegalForms",
        meta: {
          breadcrumb: "Legal forms",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/LegalForms.vue")
      },
      {
        path: "regions",
        name: "SandboxRegions",
        meta: {
          breadcrumb: "Regions",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/CountryRegions.vue")
      },

      {
        path: "banners",
        name: "SandboxBannersManagement",
        meta: {
          breadcrumb: "Banners",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/BannersManagement.vue")
      },
      {
        path: "competition_levels",
        name: "SandboxCompetitionLevelsList",
        meta: {
          breadcrumb: "Competition levels",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/CompetitionLevelsList.vue")
      },
      {
        path: "survey_elements",
        name: "SandboxSurveyElementsMasterdata",
        meta: {
          breadcrumb: "Survey elements",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/SurveyElements/index.vue")
      },
      {
        path: "rules",
        name: "SandboxRules",
        meta: {
          breadcrumb: "Rules",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/Rules/Rules.vue")
      },
      {
        path: "charts",
        name: "SandboxCharts",
        meta: {
          breadcrumb: "Charts",
          requireAuthorize: true
        },
        component: () =>
          import("@/components/sandbox/masterdata/charts/ChartList.vue")
      },

      {
        path: "chartrules",
        name: "SandboxChartRules",
        component: () =>
          import(
            "@/components/sandbox/masterdata/charts/chartRule/ChartRules.vue"
          ),
        meta: { requireAuthorize: true, breadcrumb: "Chart rules" }
      },
      {
        path: "chartrule/new",
        name: "SandboxChartRuleNew",
        component: () =>
          import(
            "@/components/sandbox/masterdata/charts/chartRule/ChartRuleForm.vue"
          ),
        meta: { requireAuthorize: true, breadcrumb: "New charts rule" }
      },
      {
        path: "chartrule/:chartRuleId/edit",
        name: "SandboxChartRuleEdit",
        props: true,
        component: () =>
          import(
            "@/components/sandbox/masterdata/charts/chartRule/ChartRuleForm.vue"
          ),
        meta: { requireAuthorize: true, breadcrumb: "Edit chart rule" }
      },

      {
        path: "qualification_groups",
        name: "SandboxQualificationGroups",
        props: true,
        component: () =>
          import(
            "@/components/sandbox/masterdata/qualifications/QualificationGroups.vue"
          ),
        meta: { requireAuthorize: true, breadcrumb: "Qualification groups" }
      },
      {
        path: "qualifications",
        name: "SandboxQualifications",
        props: true,
        component: () =>
          import(
            "@/components/sandbox/masterdata/qualifications/Qualifications.vue"
          ),
        meta: { requireAuthorize: true, breadcrumb: "Qualification groups" }
      },

      {
        path: "qualification_rules",
        name: "SandboxQualificationRules",
        component: () =>
          import(
            "@/components/sandbox/masterdata/qualifications/qualificationRule/QualificationRules.vue"
          ),
        meta: { requireAuthorize: true, breadcrumb: "Qualification rules" }
      },
      {
        path: "qualification_rules/:qualificationRuleId/edit",
        name: "SandboxQualificationRuleEdit",
        props: true,
        component: () =>
          import(
            "@/components/sandbox/masterdata/qualifications/qualificationRule/QualificationRuleEdit.vue"
          ),
        meta: { requireAuthorize: true, breadcrumb: "Edit qualification rule" }
      },
      {
        path: "qualification_rules/new",
        name: "SandboxQualificationRuleNew",
        component: () =>
          import(
            "@/components/sandbox/masterdata/qualifications/qualificationRule/QualificationRuleEdit.vue"
          ),
        meta: { requireAuthorize: true, breadcrumb: "New qualification rule" }
      },

      {
        path: "horse_breeds",
        name: "SandboxHorseBreeds",
        component: () =>
          import("@/components/sandbox/masterdata/BreedsList.vue"),
        meta: { requireAuthorize: true, breadcrumb: "Horse breeds" }
      },
      {
        path: "horse_studbooks",
        name: "SandboxHorseStudbooks",
        component: () =>
          import("@/components/sandbox/masterdata/Studbooks.vue"),
        meta: { requireAuthorize: true, breadcrumb: "Horse studbooks" }
      },
      {
        path: "horse_colors",
        name: "SandboxHorseColors",
        component: () =>
          import("@/components/sandbox/masterdata/HorseColors.vue"),
        meta: { requireAuthorize: true, breadcrumb: "Horse colors" }
      },
      {
        path: "horse_document_issuing_bodies",
        name: "SandboxHorseDocumentIssuingBodies",
        component: () =>
          import(
            "@/components/sandbox/masterdata/HorseDocumentIssuingBodies.vue"
          ),
        meta: { requireAuthorize: true, breadcrumb: "Horse document issuers" }
      },

      {
        path: "event_info_categories",
        name: "SandboxEventInfoCategoriesList",
        component: () =>
          import("@/components/sandbox/masterdata/EventInfoCategoriesList.vue"),
        meta: { requireAuthorize: true, breadcrumb: "Event info categories" }
      },
      {
        path: "event_product_categories",
        name: "SandboxEventProductCategoriesList",
        component: () =>
          import(
            "@/components/sandbox/masterdata/EventProductCategories/EventProductCategories.vue"
          ),
        meta: { requireAuthorize: true, breadcrumb: "Event product categories" }
      },

      {
        path: "user_roles",
        name: "SandboxUserRoles",
        component: () =>
          import("@/components/sandbox/masterdata/RolesList/index.vue"),
        meta: { requireAuthorize: true, breadcrumb: "User roles" }
      },
      {
        path: "user_role_comparisions",
        name: "SandboxRoleComparisionsTable",
        component: () =>
          import(
            "@/components/sandbox/masterdata/RolesList/permissions_table/index.vue"
          ),
        meta: { anchor: "#jumpMobile", breadcrumb: "Roles comparisions" }
      },

      {
        path: "exam_groups",
        name: "SandboxExamGroups",
        component: () =>
          import("@/components/sandbox/masterdata/exams/ExamGroups.vue"),
        meta: { anchor: "#jumpMobile", breadcrumb: "Exam groups" }
      },
      {
        path: "exam_definitions",
        name: "SandboxExamDefinitions",
        component: () =>
          import("@/components/sandbox/masterdata/exams/ExamDefinitions.vue"),
        meta: { anchor: "#jumpMobile", breadcrumb: "Exam definitions" }
      },

      {
        path: "certificate_groups",
        name: "SandboxCertificateGroups",
        component: () =>
          import(
            "@/components/sandbox/masterdata/certificates/CertificateGroups.vue"
          ),
        meta: { anchor: "#jumpMobile", breadcrumb: "Certificate groups" }
      },
      {
        path: "cerfiticate_definitions",
        name: "SandboxCertificateDefinitions",
        component: () =>
          import(
            "@/components/sandbox/masterdata/certificates/CertificateDefinitions.vue"
          ),
        meta: { anchor: "#jumpMobile", breadcrumb: "Certificate definitions" }
      },

      {
        path: "licence_categories",
        name: "SandboxLicenceCategoriesList",
        component: () =>
          import("@/components/sandbox/masterdata/LicenceCategoriesList.vue"),
        meta: { anchor: "#jumpMobile", breadcrumb: "Licence categories" }
      },
      {
        path: "insurance_categories",
        name: "SandboxInsuranceCategories",
        component: () =>
          import("@/components/sandbox/masterdata/InsuranceCategories.vue"),
        meta: { anchor: "#jumpMobile", breadcrumb: "Insurance categories" }
      },
      {
        path: "licence_category_checks",
        name: "SandboxLicenceChecks",
        component: () =>
          import("@/components/sandbox/masterdata/LicenceChecks.vue"),
        meta: { anchor: "#jumpMobile", breadcrumb: "Licence checks" }
      },

      {
        path: "prof_qualification_groups",
        name: "SandboxProfQualificationGroupsList",
        component: () =>
          import(
            "@/components/sandbox/masterdata/ProfQualificationGroupsList.vue"
          ),
        meta: {
          anchor: "#jumpMobile",
          breadcrumb: "Prof. Qualification groups"
        }
      },
      {
        path: "prof_qualifications",
        name: "SandboxProfQualificationsList",
        component: () =>
          import("@/components/sandbox/masterdata/ProfQualificationsList.vue"),
        meta: {
          anchor: "#jumpMobile",
          breadcrumb: "Prof. Qualifications"
        }
      },

      {
        path: "eventcodes",
        name: "SandboxEventcodesList",
        component: () =>
          import("@/components/sandbox/masterdata/EventcodesList.vue"),
        meta: {
          anchor: "#jumpMobile",
          breadcrumb: "Eventcodes"
        }
      },
      {
        path: "difficulty_levels",
        name: "SandboxDifficultyLevelsList",
        component: () =>
          import("@/components/sandbox/masterdata/DifficultyLevelsList.vue"),
        meta: {
          anchor: "#jumpMobile",
          breadcrumb: "Difficulty levels"
        }
      },
      {
        path: "event_categories",
        name: "SandboxEventCategories",
        component: () =>
          import(
            "@/components/sandbox/masterdata/EventCategories/EventCategories.vue"
          ),
        meta: {
          anchor: "#jumpMobile",
          breadcrumb: "Event categories"
        }
      },

      {
        path: "competition_rules",
        name: "SandboxCompetitionRulesList",
        component: () =>
          import("@/components/sandbox/masterdata/CompetitionRulesList.vue"),
        meta: {
          anchor: "#jumpMobile",
          breadcrumb: "Competition rules"
        }
      },
      {
        path: "competition_sections",
        name: "SandboxCompetitionSectionsList",
        component: () =>
          import("@/components/sandbox/masterdata/CompetitionSectionsList.vue"),
        meta: {
          anchor: "#jumpMobile",
          breadcrumb: "Competition sections"
        }
      },
      {
        path: "competition_entry_rule_templates",
        name: "SandboxCompetitionEntryRuleTemplates",
        component: () =>
          import(
            "@/components/sandbox/masterdata/CompetitionEntryRuleTemplates.vue"
          ),
        meta: {
          anchor: "#jumpMobile",
          breadcrumb: "Competition entry rule templates"
        }
      },

      {
        path: "cups",
        name: "SandboxCupsList",
        component: () => import("@/components/sandbox/masterdata/CupsList.vue"),
        meta: {
          anchor: "#jumpMobile",
          breadcrumb: "Cups"
        }
      },
      {
        path: "cup_seasons",
        name: "SandboxCupsSeasonList",
        component: () =>
          import("@/components/sandbox/masterdata/CupsSeasonsList.vue"),
        meta: {
          anchor: "#jumpMobile",
          breadcrumb: "Cup seasons"
        }
      },

      {
        path: "competing/difficulty_level_groups",
        name: "SandboxCompetingDifficultyLevelGroups",
        component: () =>
          import(
            "@/components/sandbox/masterdata/competing/CompetingDifficultyLevelGroups.vue"
          ),
        meta: {
          anchor: "#jumpMobile",
          breadcrumb: "Competing difficulty level groups"
        }
      },
      {
        path: "competing/difficulty_level_definitions",
        name: "SandboxCompetingDifficultyLevelDefinitions",
        component: () =>
          import(
            "@/components/sandbox/masterdata/competing/CompetingDifficultyLevelDefinitions.vue"
          ),
        meta: {
          anchor: "#jumpMobile",
          breadcrumb: "Competing difficulty level definitions"
        }
      },
      {
        path: "competing/difficulty_level_rules",
        name: "SandboxCompetingDifficultyLevelRules",
        component: () =>
          import(
            "@/components/sandbox/masterdata/competing/CompetingDifficultyLevelRules.vue"
          ),
        meta: {
          anchor: "#jumpMobile",
          breadcrumb: "Competing difficulty level rules"
        }
      }
    ]
  }
];
